// copy elements of object to array
const copyObjectToArray = (obj) => {
    // initialize array
    let copyArray = []; 
    // add all elements of object to array 
    Object.keys(obj).map( el => {
        copyArray.push({
            ...obj[el], 
        }); 
    }); 
    // return copy 
    return copyArray; 
}

export default copyObjectToArray; 